module.exports = __webpack_public_path__ + "static/media/50.96a59d7b.png";